import React from 'react';
import { styled } from '@compiled/react';
import isNil from 'lodash/isNil';
import { token } from '@atlaskit/tokens';
import { FieldHeadingTitle } from '@atlassian/jira-issue-field-heading/src/styled.tsx';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import messages from './messages.tsx';
import type { DateFieldProps } from './types.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const EmptyValue = styled.div({
	color: token('color.text'),
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const DateLabel = styled(FieldHeadingTitle)<{ isVisualRefreshEnabled?: boolean }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		// eslint-disable-next-line @typescript-eslint/no-shadow, @atlaskit/ui-styling-standard/no-dynamic-styles
		'font-weight': ({ isVisualRefreshEnabled }) =>
			isVisualRefreshEnabled ? token('font.weight.regular') : '500',
		// eslint-disable-next-line @typescript-eslint/no-shadow, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		color: ({ isVisualRefreshEnabled }) =>
			isVisualRefreshEnabled ? undefined : token('color.text'),
	},
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const ReadContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	marginBottom: token('space.100'),

	color: token('color.text'),
});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ label, date, intl: { formatDate, formatMessage } }: DateFieldProps) => (
	<>
		<DateLabel isVisualRefreshEnabled={isVisualRefreshEnabled()}>{label}</DateLabel>
		{!isNil(date) ? (
			<ReadContainer>
				{formatDate(date, {
					year: 'numeric',
					month: 'long',
					day: 'numeric',
					timeZone: 'UTC',
				})}
			</ReadContainer>
		) : (
			<EmptyValue>{formatMessage(messages.none)}</EmptyValue>
		)}
	</>
);
